<template>
    <div>
        <q-page-container>
            <div style="position: relative" v-if="isShowDisplay">
                <template>
                    <transition name="slide" mode="out-in">
                        <router-view :key="$route.fullPath" language="en"></router-view>
                    </transition>
                </template>
            </div>
            <initial-loader v-else />
        </q-page-container>
    </div>
</template>

<script>
export default {
    props: ['toggleDrawer'],
    components: {},
    mounted() {},
    methods: {},

    data() {
        return {
            home: false,
            key: 0,
            drawer: true,
        };
    },
    computed: {
        isShowDisplay() {
            return this.$store.state.showDisplay;
        },
    },
};
</script>
<style lang="scss">
@import '../styles/quasar.scss';
@import '../styles/vueRouterTab.scss';

.blueColor {
    color: $blueColor;
}

.greyBlackBgColor {
    background-color: $greyBlack;
}
.slide-enter-active,
.slide-leave-active {
    transition: all 0.3s ease;
}

.slide-enter {
    opacity: 0;
    transform: translateX(30px);
}

.slide-leave-to {
    opacity: 0;
    transform: translateX(-30px);
}
</style>
